import { createContext, useContext } from 'react';

export const AlertContext = createContext({
    showAlert: false,
    messageAlert: '',
    homeLink: '/auth/login',
    setShowAlert: () => {},
    setMessageAlert: () => {},
    setHomeLink: () => {},
});

export const useAlert = () => useContext(AlertContext);